import * as React from "react";
const LegalInactiveSVG = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.489 5.49723C18.752 5.4975 19.0041 5.60208 19.19 5.78801C19.3759 5.97393 19.4805 6.22601 19.4808 6.48895V18.4691C19.4805 18.732 19.3759 18.9841 19.19 19.1701C19.0041 19.356 18.752 19.4605 18.489 19.4608H6.51044C6.24754 19.4604 5.99553 19.3558 5.80963 19.1699C5.62374 18.984 5.51912 18.732 5.51872 18.4691V6.48895C5.51899 6.22601 5.62355 5.97393 5.80948 5.78801C5.9954 5.60208 6.2475 5.4975 6.51044 5.49723H18.4896M18.4896 4.47852H6.51044C5.97723 4.47852 5.46587 4.69034 5.08884 5.06737C4.71181 5.4444 4.5 5.95575 4.5 6.48895V18.4691C4.50027 19.0021 4.71219 19.5132 5.0892 19.89C5.4662 20.2668 5.97741 20.4785 6.51044 20.4785H18.4896C19.0228 20.4785 19.5341 20.2667 19.9112 19.8897C20.2882 19.5126 20.5 19.0013 20.5 18.4681V6.48895C20.5 5.95575 20.2882 5.4444 19.9112 5.06737C19.5341 4.69034 19.0228 4.47852 18.4896 4.47852Z"
      fill="#888E9E"
    />
    <path
      d="M16.587 11.0763H8.53353C8.39844 11.0763 8.26887 11.0227 8.17335 10.9271C8.07783 10.8316 8.02417 10.7021 8.02417 10.567C8.02417 10.4319 8.07783 10.3023 8.17335 10.2068C8.26887 10.1113 8.39844 10.0576 8.53353 10.0576H16.587C16.7221 10.0576 16.8517 10.1113 16.9472 10.2068C17.0427 10.3023 17.0964 10.4319 17.0964 10.567C17.0964 10.7021 17.0427 10.8316 16.9472 10.9271C16.8517 11.0227 16.7221 11.0763 16.587 11.0763Z"
      fill="#888E9E"
    />
    <path
      d="M16.587 15.1037H8.53353C8.39844 15.1037 8.26887 15.05 8.17335 14.9545C8.07783 14.859 8.02417 14.7294 8.02417 14.5943C8.02417 14.4592 8.07783 14.3297 8.17335 14.2341C8.26887 14.1386 8.39844 14.085 8.53353 14.085H16.587C16.7221 14.085 16.8517 14.1386 16.9472 14.2341C17.0427 14.3297 17.0964 14.4592 17.0964 14.5943C17.0964 14.7294 17.0427 14.859 16.9472 14.9545C16.8517 15.05 16.7221 15.1037 16.587 15.1037Z"
      fill="#888E9E"
    />
  </svg>
);
export default LegalInactiveSVG;
